(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enhanced-product-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sm-enhanced-content')) {
    customElements.define('sm-enhanced-content', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        const track = this.querySelector('.sm-enhanced__photo-track');
        if (track) {
          const seen = new Set();
          const cards = Array.from(track.children).filter((card) => {
            if (seen.has(card.dataset.photoUrl)) { card.remove(); return false; }
            seen.add(card.dataset.photoUrl); return true;
          });
          const matching = cards.filter((card) => card.dataset.photoProduct === this.dataset.productId);
          const other = cards.filter((card) => card.dataset.photoProduct !== this.dataset.productId);
          if (this.dataset.rotateOther === 'true') {
            for (let i = other.length - 1; i > 0; i -= 1) {
              const j = Math.floor(Math.random() * (i + 1));
              [other[i], other[j]] = [other[j], other[i]];
            }
          }
          track.append(...matching, ...other);
          const controls = this.querySelector('.sm-enhanced__gallery-controls');
          const previous = this.querySelector('[data-gallery-direction="-1"]');
          const next = this.querySelector('[data-gallery-direction="1"]');
          const update = () => {
            const overflow = track.scrollWidth - track.clientWidth;
            controls.hidden = overflow < 2;
            previous.disabled = track.scrollLeft <= 2;
            next.disabled = track.scrollLeft >= overflow - 2;
          };
          const move = (direction) => track.scrollBy({ left: direction * ((track.firstElementChild?.getBoundingClientRect().width || track.clientWidth) + parseFloat(getComputedStyle(track).gap || '0')), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          controls.addEventListener('click', (event) => {
            const button = event.target.closest('[data-gallery-direction]');
            if (button) move(Number(button.dataset.galleryDirection));
          }, { signal });
          track.addEventListener('keydown', (event) => {
            if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
            event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1);
          }, { signal });
          track.addEventListener('scroll', update, { passive: true, signal });
          this.resizeObserver = new ResizeObserver(update);
          this.resizeObserver.observe(track);
          update();
        }
        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-choose-size]');
          if (!link) return;
          const form = document.querySelector('main product-form');
          const options = form?.querySelectorAll('variant-picker .option-selector');
          const size = Array.from(options || []).find((option) => option.dataset.option?.toLowerCase() === 'size');
          const target = size?.querySelector('custom-select .custom-select__btn') || size?.querySelector('input[type="radio"]:checked, input[type="radio"]:not(:disabled), select:not([hidden])');
          if (!target) return;
          event.preventDefault();
          size.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          target.focus({ preventScroll: true });
        }, { signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!customElements.get('recently-viewed-page-nav')) {
    class RecentlyViewedPageNavigation extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-recently-viewed-page-viewport]');
        this.previousButton = this.querySelector('[data-recently-viewed-page-direction="prev"]');
        this.nextButton = this.querySelector('[data-recently-viewed-page-direction="next"]');
        if (!this.viewport || !this.previousButton || !this.nextButton) return;
        this.handleClick = this.handleClick.bind(this);
        this.updateButtons = this.updateButtons.bind(this);
        this.addEventListener('click', this.handleClick);
        this.viewport.addEventListener('scroll', this.updateButtons, { passive: true });
        this.resizeObserver = new ResizeObserver(this.updateButtons);
        this.resizeObserver.observe(this.viewport);
        this.updateButtons();
      }

      disconnectedCallback() {
        if (!this.viewport) return;
        this.removeEventListener('click', this.handleClick);
        this.viewport.removeEventListener('scroll', this.updateButtons);
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      getPageDistance() {
        const items = [...this.querySelectorAll('.slider__grid > .slider__item')];
        if (items.length < 2) return this.viewport.clientWidth;
        const itemSpan = items[1].offsetLeft - items[0].offsetLeft;
        if (itemSpan <= 0) return this.viewport.clientWidth;
        const itemGap = itemSpan - items[0].clientWidth;
        const itemsPerPage = Math.max(1, Math.floor((this.viewport.clientWidth + itemGap) / itemSpan));
        return itemsPerPage * itemSpan;
      }

      handleClick(event) {
        const button = event.target.closest('[data-recently-viewed-page-direction]');
        if (!button) return;
        const direction = button.dataset.recentlyViewedPageDirection === 'next' ? 1 : -1;
        this.viewport.scrollBy({ left: direction * this.getPageDistance(), behavior: 'smooth' });
      }

      updateButtons() {
        const maximumScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        const currentScroll = Math.abs(this.viewport.scrollLeft);
        this.previousButton.disabled = currentScroll <= 2;
        this.nextButton.disabled = maximumScroll <= 2 || currentScroll >= maximumScroll - 2;
      }

      refresh() {
        window.requestAnimationFrame(this.updateButtons);
      }
    }

    customElements.define('recently-viewed-page-nav', RecentlyViewedPageNavigation);
  }

  const rootSelector = '[data-recently-viewed-section]';
  const observerRootMargin = '300px 0px';
  const CARD_VIEW_QUERY = '?view=card';

  const toInt = (value, fallback) => {
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? fallback : parsed;
  };

  const safeParse = (value, fallback) => {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  };

  const getProductIdentity = (root) => {
    if (!root) return null;
    const handle = root.dataset.currentHandle || '';
    const id = root.dataset.currentId || '';
    if (!handle) return null;
    return { handle, id };
  };

  const isDebugEnabled = (root) => {
    if (!root) return false;
    return root.dataset.debug === 'true';
  };

  const debugLog = (root, ...args) => {
    if (!isDebugEnabled(root)) return;
    try {
      console.log('[RecentlyViewed]', ...args);
    } catch (error) {
      // Ignore console errors.
    }
  };

  const storageKeys = {
    list: 'sm_recently_viewed_products_v1',
    cachePrefix: 'sm_recently_viewed_card_'
  };

  const readList = () => {
    try {
      const raw = window.localStorage.getItem(storageKeys.list);
      const parsed = safeParse(raw, []);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const writeList = (items) => {
    try {
      window.localStorage.setItem(storageKeys.list, JSON.stringify(items));
    } catch (error) {
      // Intentionally ignore storage failures.
    }
  };

  const saveCurrentProduct = (root, storageLimit) => {
    const current = getProductIdentity(root);
    if (!current) return;

    const existing = readList();
    const deduped = existing.filter((item) => item && item.handle && item.handle !== current.handle);
    deduped.unshift({ handle: current.handle, id: current.id, ts: Date.now() });
    const finalList = deduped.slice(0, storageLimit);
    writeList(finalList);
    debugLog(root, 'track', current);
    debugLog(root, 'stored', finalList);
  };

  const getCache = (handle) => {
    try {
      return window.sessionStorage.getItem(`${storageKeys.cachePrefix}${handle}`) || '';
    } catch (error) {
      return '';
    }
  };

  const setCache = (handle, html) => {
    try {
      window.sessionStorage.setItem(`${storageKeys.cachePrefix}${handle}`, html);
    } catch (error) {
      // Intentionally ignore cache write failures.
    }
  };

  const fetchCardHtml = (root, handle) => {
    const cached = getCache(handle);
    if (cached) {
      debugLog(root, 'fetch cache hit', handle);
      return Promise.resolve(cached);
    }

    const url = `/products/${handle}${CARD_VIEW_QUERY}`;
    debugLog(root, 'fetch start', url);

    return fetch(url, { credentials: 'same-origin' })
      .then((response) => {
        debugLog(root, 'fetch response', url, response.status);
        if (!response.ok) throw new Error('Failed to fetch product card view');
        return response.text();
      })
      .then((html) => {
        setCache(handle, html);
        return html;
      })
      .catch(() => {
        debugLog(root, 'fetch failed', url);
        return '';
      });
  };

  const buildHandlesToRender = (root, limit) => {
    const current = getProductIdentity(root);
    const currentHandle = current ? current.handle : '';

    const handles = readList()
      .filter((item) => item && item.handle && item.handle !== currentHandle)
      .map((item) => item.handle)
      .filter((handle, index, arr) => arr.indexOf(handle) === index)
      .slice(0, limit);

    debugLog(root, 'render handles', handles);
    return handles;
  };

  const runThemeInitializers = (gridNode) => {
    if (!window.theme) return;

    window.requestAnimationFrame(() => {
      if (window.theme.ProductBlockManager && typeof window.theme.ProductBlockManager.loadImages === 'function') {
        window.theme.ProductBlockManager.loadImages(gridNode);
      }
      if (typeof window.theme.initAltThumbs === 'function') {
        window.theme.initAltThumbs(gridNode);
      }
      if (typeof window.theme.initAnimateOnScroll === 'function') {
        window.theme.initAnimateOnScroll();
      }

      const slider = gridNode && gridNode.closest ? gridNode.closest('carousel-slider') : null;
      if (slider && typeof slider.refresh === 'function') {
        slider.refresh();
      }

      const pageNavigation = gridNode && gridNode.closest ? gridNode.closest('recently-viewed-page-nav') : null;
      if (pageNavigation && typeof pageNavigation.refresh === 'function') {
        pageNavigation.refresh();
      }
    });
  };

  const showRoot = (root) => {
    if (!root) return;
    root.classList.remove('recently-viewed-products-row--pending');
  };

  const hideRoot = (root) => {
    if (!root) return;
    root.hidden = true;
  };

  const isCarouselEnabled = (root) => root && root.dataset.enableCarousel === 'true';

  const buildGridMarkup = (root, responses) => {
    const cards = responses.filter((html) => html && html.trim());
    if (!cards.length) return '';

    if (!isCarouselEnabled(root)) {
      return cards.join('');
    }

    return cards.map((html) => `<div class="slider__item">${html}</div>`).join('');
  };

  const renderSection = (root) => {
    if (!root || root.dataset.recentlyViewedLoaded === 'true') return;

    const grid = root.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    root.dataset.recentlyViewedLoaded = 'true';
    const limit = toInt(root.dataset.limit, 6);
    const handles = buildHandlesToRender(root, limit);

    if (!handles.length) {
      hideRoot(root);
      return;
    }

    const gridCols = Math.max(1, toInt(root.dataset.grid, 4));
    root.style.setProperty('--rv-min-height', `${Math.max(240, 420)}px`);

    Promise.all(handles.map((handle) => fetchCardHtml(root, handle)))
      .then((responses) => {
        const markup = buildGridMarkup(root, responses);
        if (!markup.trim()) {
          hideRoot(root);
          debugLog(root, 'cards injected', false);
          return;
        }

        grid.innerHTML = markup;
        showRoot(root);
        debugLog(root, 'cards injected', true);

        const firstCard = grid.querySelector('.product-block');
        if (firstCard) {
          const cardHeight = Math.round(firstCard.getBoundingClientRect().height);
          if (cardHeight > 0) {
            const visibleCards = responses.filter((html) => html && html.trim()).length;
            const cardsForHeight = Math.max(1, visibleCards);
            const rows = isCarouselEnabled(root) ? 1 : Math.ceil(cardsForHeight / gridCols);
            const reserved = Math.max(240, Math.min(cardHeight * rows, cardHeight * 2));
            root.style.setProperty('--rv-min-height', `${reserved}px`);
          }
        }

        runThemeInitializers(grid);
      })
      .catch(() => {
        hideRoot(root);
        debugLog(root, 'cards injected', false);
      });
  };

  const trackOnPageLoad = (root) => {
    if (!root || root.dataset.recentlyViewedTracked === 'true') return;
    root.dataset.recentlyViewedTracked = 'true';
    const storageLimit = toInt(root.dataset.storageLimit, 16);
    saveCurrentProduct(root, storageLimit);
  };

  const initRoot = (root) => {
    if (!root || root.dataset.recentlyViewedBound === 'true') return;
    root.dataset.recentlyViewedBound = 'true';

    trackOnPageLoad(root);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          renderSection(root);
        });
      }, { rootMargin: observerRootMargin });
      observer.observe(root);
      return;
    }

    renderSection(root);
  };

  const initAll = (scope = document) => {
    const roots = scope.querySelectorAll(rootSelector);
    roots.forEach((root) => initRoot(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const target = event && event.target ? event.target : document;
    if (target.matches && target.matches(rootSelector)) {
      target.hidden = false;
      target.dataset.recentlyViewedLoaded = 'false';
      target.dataset.recentlyViewedBound = 'false';
      target.dataset.recentlyViewedTracked = 'false';
      target.classList.add('recently-viewed-products-row--pending');
      initRoot(target);
      return;
    }

    initAll(target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommendation-comparison"]) return;
  try {
    
  if (!customElements.get('recommendation-page-nav')) {
    class RecommendationPageNavigation extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-recommendation-page-viewport]');
        this.previousButton = this.querySelector('[data-recommendation-page-direction="prev"]');
        this.nextButton = this.querySelector('[data-recommendation-page-direction="next"]');
        this.handleClick = this.handleClick.bind(this);
        this.updateButtons = this.updateButtons.bind(this);
        this.addEventListener('click', this.handleClick);
        this.viewport.addEventListener('scroll', this.updateButtons, { passive: true });
        this.resizeObserver = new ResizeObserver(this.updateButtons);
        this.resizeObserver.observe(this.viewport);
        this.updateButtons();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.viewport.removeEventListener('scroll', this.updateButtons);
        this.resizeObserver.disconnect();
      }

      getPageDistance() {
        const items = [...this.querySelectorAll('.slider__grid > .slider__item')];
        if (items.length < 2) return this.viewport.clientWidth;
        const itemSpan = items[1].offsetLeft - items[0].offsetLeft;
        const itemGap = itemSpan - items[0].clientWidth;
        const itemsPerPage = Math.max(1, Math.floor((this.viewport.clientWidth + itemGap) / itemSpan));
        return itemsPerPage * itemSpan;
      }

      handleClick(event) {
        const button = event.target.closest('[data-recommendation-page-direction]');
        if (!button) return;
        const direction = button.dataset.recommendationPageDirection === 'next' ? 1 : -1;
        this.viewport.scrollBy({ left: direction * this.getPageDistance(), behavior: 'smooth' });
      }

      updateButtons() {
        const maximumScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
        const currentScroll = Math.abs(this.viewport.scrollLeft);
        this.previousButton.disabled = currentScroll <= 2;
        this.nextButton.disabled = currentScroll >= maximumScroll - 2;
      }
    }

    customElements.define('recommendation-page-nav', RecommendationPageNavigation);
  }

  function loadRecommendationSections(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-recommendation-loader]').forEach(function(loader) {
      if (loader.dataset.loading === 'true') return;
      loader.dataset.loading = 'true';
      fetch(loader.dataset.url)
        .then(function(response) { return response.text(); })
        .then(function(html) {
          var container = document.createElement('div');
          container.innerHTML = html;
          var replacement = container.querySelector('[data-section-id="' + loader.dataset.sectionId + '"]');
          if (replacement && replacement.innerHTML.trim()) {
            var pendingSection = loader.previousElementSibling;
            if (pendingSection && pendingSection.hasAttribute('data-recommendation-pending-native')) {
              pendingSection.replaceWith(replacement);
              loader.remove();
            } else {
              loader.replaceWith(replacement);
            }
            window.requestAnimationFrame(function() {
              if (!window.theme) return;
              if (typeof window.theme.initAltThumbs === 'function') {
                window.theme.initAltThumbs(replacement);
              }
              if (window.theme.ProductBlockManager && typeof window.theme.ProductBlockManager.loadImages === 'function') {
                window.theme.ProductBlockManager.loadImages(replacement);
              }
            });
          } else {
            loader.remove();
          }
        })
        .catch(function() { loader.remove(); });
    });
  }

  loadRecommendationSections(document);
  document.addEventListener('shopify:section:load', function(event) {
    loadRecommendationSections(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommendation-tracking"]) return;
  try {
    
  (function() {
    if (window.__suitsAndMoreRecommendationTracking) return;
    window.__suitsAndMoreRecommendationTracking = true;

    var eventPrefix = 'suits_and_more:';
    var queryKeys = {
      source: 'sam_rec_source',
      from: 'sam_rec_from',
      rank: 'sam_rec_rank',
      to: 'sam_rec_to',
      version: 'sam_rec_version'
    };

    function publish(eventName, payload) {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        var result = Shopify.analytics.publish(eventPrefix + eventName, payload);
        if (result && typeof result.catch === 'function') result.catch(function() {});
      }
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: 'sam_recommendation_' + eventName }, payload));
      }
    }

    function productIds(container) {
      return Array.from(container.querySelectorAll('[data-product-id]'))
        .map(function(node) { return node.getAttribute('data-product-id'); })
        .filter(Boolean)
        .filter(function(id, index, values) { return values.indexOf(id) === index; });
    }

    function payloadFor(container, link) {
      var productNode = link.closest('[data-product-id]');
      var positionNode = link.closest('[data-recommendation-position]');
      var cards = Array.from(container.querySelectorAll('product-block[data-product-id], a[data-product-id]'));
      var rank = positionNode && positionNode.getAttribute('data-recommendation-position');
      if (!rank && productNode) rank = cards.indexOf(productNode) + 1;

      return {
        recommendation_source: container.getAttribute('data-recommendation-source'),
        recommendation_version: container.getAttribute('data-recommendation-version'),
        source_product_id: container.getAttribute('data-recommendation-product-id'),
        recommended_product_id: productNode && productNode.getAttribute('data-product-id'),
        recommendation_rank: Number(rank) || null
      };
    }

    function decorate(link, payload) {
      try {
        var url = new URL(link.href, window.location.origin);
        if (url.origin !== window.location.origin || url.pathname.indexOf('/products/') === -1) return;
        url.searchParams.set(queryKeys.source, payload.recommendation_source || 'unknown');
        url.searchParams.set(queryKeys.from, payload.source_product_id || 'unknown');
        url.searchParams.set(queryKeys.rank, payload.recommendation_rank || 'unknown');
        url.searchParams.set(queryKeys.to, payload.recommended_product_id || 'unknown');
        url.searchParams.set(queryKeys.version, payload.recommendation_version || 'unknown');
        link.href = url.toString();
      } catch (_error) {
        return;
      }
    }

    document.addEventListener('click', function(event) {
      var link = event.target.closest && event.target.closest('a[href*="/products/"]');
      if (!link) return;
      var container = link.closest('[data-recommendation-source]');
      if (!container) return;
      var payload = payloadFor(container, link);
      decorate(link, payload);
      publish('recommendation_click', payload);
    });

    var seen = new WeakSet();
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5 || seen.has(entry.target)) return;
        var ids = productIds(entry.target);
        if (!ids.length) return;
        seen.add(entry.target);
        observer.unobserve(entry.target);
        publish('recommendation_impression', {
          recommendation_source: entry.target.getAttribute('data-recommendation-source'),
          recommendation_version: entry.target.getAttribute('data-recommendation-version'),
          source_product_id: entry.target.getAttribute('data-recommendation-product-id'),
          recommended_product_ids: ids
        });
      });
    }, { threshold: [0.5] });

    function observeRecommendations(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('[data-recommendation-source]').forEach(function(container) {
        if (!seen.has(container)) observer.observe(container);
      });
    }

    function attributionFromUrl() {
      var params = new URLSearchParams(window.location.search);
      var source = params.get(queryKeys.source);
      if (!source) return null;
      return {
        source: source,
        from: params.get(queryKeys.from),
        rank: params.get(queryKeys.rank),
        to: params.get(queryKeys.to),
        version: params.get(queryKeys.version)
      };
    }

    function addLineItemProperty(form, name, value) {
      if (!value) return;
      var selector = 'input[name="properties[' + name + ']"]';
      var input = form.querySelector(selector);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + name + ']';
        form.appendChild(input);
      }
      input.value = value;
    }

    function applyAttribution() {
      var attribution = attributionFromUrl();
      if (!attribution) return;
      document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form) {
        addLineItemProperty(form, '_sam_recommendation_source', attribution.source);
        addLineItemProperty(form, '_sam_recommendation_from', attribution.from);
        addLineItemProperty(form, '_sam_recommendation_rank', attribution.rank);
        addLineItemProperty(form, '_sam_recommendation_version', attribution.version);
      });
    }

    var landing = attributionFromUrl();
    if (landing) {
      publish('recommendation_landing', {
        recommendation_source: landing.source,
        recommendation_version: landing.version,
        source_product_id: landing.from,
        recommended_product_id: landing.to,
        recommendation_rank: Number(landing.rank) || null
      });
    }

    observeRecommendations(document);
    applyAttribution();

    document.addEventListener('shopify:section:load', function(event) {
      observeRecommendations(event.target);
      applyAttribution();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
